import React, { useEffect, useState } from 'react';
import CurrentTemp from './components/CurrentTemp';
import TempChart from './components/TempChart';

function App() {
  const [temps, setTemps] = useState([]);

  const fetchTemps = async () => {
    const res = await fetch('https://api.fullstackmitch.com/api/temperatures/');
    const data = await res.json();
    setTemps(data.reverse());
  };

  useEffect(() => {
    fetchTemps();
    const interval = setInterval(fetchTemps, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <h1>Temperature Monitor</h1>
      <CurrentTemp temp={temps[temps.length - 1]} />
      <TempChart temps={temps} />
    </div>
  );
}

export default App;